<template>
  <div id="referring-platform">
    <b-container class="referring-platform-body pb-5">
      <referring-platform-header
        :referringPlatformAppResource="this.referringPlatformAppResource"
        v-if="this.isBranded"
      />
      <slot />
      <referring-platform-footer
        :referringPlatformAppResource="this.referringPlatformAppResource"
        v-if="this.isBranded"
      />
    </b-container>
  </div>
</template>

<script>
import ReferringPlatformHeader from "./ReferringPlatformHeader";
import ReferringPlatformFooter from "./ReferringPlatformFooter";

export default {
  name: "ReferringPlatformBranding",
  props: {
    referringPlatformAppResource: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ReferringPlatformHeader,
    ReferringPlatformFooter,
  },
  computed: {
    isBranded() {
      return Boolean(this.referringPlatformAppResource?.branded);
    },
  },
};
</script>
